<ng-template #costOverrideUpload let-modal>
	<div class="modal-header d-flex justify-content-between align-items-center">
		<div>
			<h4 class="modal-title">Upload Cost Overrides</h4>
			<h6 *ngIf="costOverrideReviewReady" class="text-muted mb-0">Files: {{ costOverrideFiles.length }}</h6>
		</div>
		<div>
			<button mat-stroked-button class="pomodalbtn me-2" (click)="$event.preventDefault(); toggleCostOverrideHelp()">Help</button>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<i class="fa fa-close"></i>
			</button>
		</div>
	</div>

	<div class="modal-body pomodalbody">
		<ng-container *ngIf="!costOverrideHelp">
			<ngx-dropzone (change)="onCostOverrideSelect($event)" *ngIf="!costOverride_processing_recs && !costOverrideReviewReady" class="dropzone">
				<ngx-dropzone-label class="dropzone-label">Drop file, or click to upload!</ngx-dropzone-label>
				<ngx-dropzone-preview *ngFor="let f of costOverrideFiles" [removable]="true" (removed)="onCostOverrideRemove(f)">
					<ngx-dropzone-label class="overflow-auto">{{ f.name }}</ngx-dropzone-label>
				</ngx-dropzone-preview>
			</ngx-dropzone>
			<div *ngIf="costOverride_processing_recs" class="text-center py-4">
				<svg class="spinner" width="65" height="65" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
				</svg>
			</div>
			<mat-tab-group *ngIf="costOverrideReviewReady">
				<!-- Raw Data Tab -->
				<mat-tab *ngIf="costOverrideUploadedRawData?.length">
					<ng-template mat-tab-label>
						Data Mapping & Processing &nbsp;&nbsp;<mat-icon class="text-info ms-1">table_chart</mat-icon>
					</ng-template>
					<div class="mt-3">
						<!-- Mapping summary -->
						<div class="mb-3">
							<h6 class="text-muted fw-bold small">Field Mapping Summary:</h6>
							<ul class="mb-2 ps-3 small">
								<li *ngFor="let map of mappedFieldPairs">
									<code>{{ map.original }}</code> → <strong>{{ map.mapped }}</strong>
								</li>
							</ul>
						</div>
						<div class="d-flex justify-content-between align-items-center mb-2">
							<div *ngIf="isSearching" class="text-muted small d-flex align-items-center">
								<span class="spinner-border spinner-border-sm me-2"></span>
								Searching batch {{ currentBatch + 1 }} of {{ totalBatches }}... {{ totalProcessed }} Processed
							</div>
							<div class="btn-group ms-auto" role="group">

								<button class="btn btn-sm btn-outline-primary" [disabled]="isSearching" (click)="searchMissingSKUs()" *ngIf="unmatchedItems.length" [disabled]="isSearching || !isBrandAndPartnoMapped()">
									Search Missing SKUs
								</button>

								<div
									*ngIf="!isBrandAndPartnoMapped() && unmatchedItems.length"
									class="text-danger small mt-1"
								>
									&nbsp;&nbsp;&nbsp;Please map both <strong>brand</strong> and <strong>partno</strong> before searching.
								</div>

								<button class="btn btn-sm btn-outline-secondary" [disabled]="isSearching" (click)="resetCostOverrideUpload()">
									Reset
								</button>
								<button class="btn btn-sm btn-success" [disabled]="isSearching" (click)="processMatchedRows()" *ngIf="matchedItems.length">
									Process Matched ( {{matchedItems.length}})
								</button>
							</div>
						</div>

						<div class="table-responsive">
							<table class="table table-sm table-hover align-middle override-mapping-table shadow-sm rounded">
							  <thead class="thead-dark border-bottom border-2">
								<tr>
								  <th *ngFor="let header of costOverrideSelectedFile === 'all' ? costOverrideUploadedHeaders : costOverrideFileSpecificHeaders[costOverrideSelectedFile]" class="text-uppercase small fw-bold px-2 py-1">
									{{ header }}
								  </th>
								</tr>
								<tr>
								  <th *ngFor="let header of costOverrideSelectedFile === 'all' ? costOverrideUploadedHeaders : costOverrideFileSpecificHeaders[costOverrideSelectedFile]" class="p-1">
									<select
									  class="form-select form-select-sm override-mapping-select border-0 bg-light"
									  [(ngModel)]="costOverrideSelectedFile === 'all' ? costOverrideColumnMappings[header] : costOverrideFileSpecificMappings[costOverrideSelectedFile][header]"
									  (change)="updateCostOverrideColumnMapping(header, $event.target.value, costOverrideSelectedFile !== 'all' ? costOverrideSelectedFile : null)">
									 <option
										 *ngFor="let type of costOverrideAvailableFieldTypes"
										 [value]="type"
										 [disabled]="isFieldTypeAlreadyUsed(type, header) && type !== getCurrentMapping(header)">
										 {{ type }}
									 </option>

									</select>
								  </th>
								</tr>
							  </thead>
							  <tbody>
								<tr
								  *ngFor="let row of costOverrideUploadedRawData"
								  [hidden]="costOverrideSelectedFile !== 'all' && row._sourceFile !== costOverrideSelectedFile"
								  [ngClass]="{
									'bg-danger-subtle text-danger fw-semibold': row._stockid_missing === true || !row.stockid,
									'bg-success-subtle text-success': row._stockid_missing === false && !!row.stockid
								  }">
								  <td
									*ngFor="let header of costOverrideSelectedFile === 'all' ? costOverrideUploadedHeaders : costOverrideFileSpecificHeaders[costOverrideSelectedFile]"
									class="small px-2 py-1"
								  >
									{{ row[header] }}
								  </td>
								</tr>
							  </tbody>
							</table>

						</div>
					</div>
				</mat-tab>
				<!-- Unmatched SKUs -->
				<mat-tab *ngIf="unmatchedItems.length">
					<ng-template mat-tab-label>
						Unmatched &nbsp;&nbsp; ({{ unmatchedCount }})
						<mat-icon class="text-danger ms-1">cancel</mat-icon>
					</ng-template>

					<table class="table table-striped table-sm mt-3">
						<thead class="thead-dark">
							<tr>
								<th>Stock ID</th>
								<th>Description</th>
								<th>Override Cost</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of unmatchedItems" [ngClass]="{ 'table-warning': item.mappingError, 'table-danger': true }">
								<td>{{ item.stockid || '—' }}</td>
								<td>{{ item.description }}</td>
								<td>{{ item[getMappedOriginalField('cost')] | currency }}</td>
							</tr>
						</tbody>
					</table>
				</mat-tab>

				<mat-tab *ngIf="matchedOriginalRows.length">
					<ng-template mat-tab-label>
						Review Matched ({{ matchedOriginalRows.length }})
						<mat-icon class="text-primary ms-1">visibility</mat-icon>
					</ng-template>

					<div class="mt-3">

						<!-- Mapping summary -->
						<div class="mb-3">
							<h6 class="text-muted fw-bold small">Field Mapping Summary:</h6>
							<ul class="mb-2 ps-3 small">
								<li *ngFor="let map of mappedFieldPairs">
									<code>{{ map.original }}</code> → <strong>{{ map.mapped }}</strong>
								</li>
							</ul>
						</div>

						<!-- Table of mapped values -->
						<div class="table-responsive">
							<table class="table table-bordered table-sm table-hover shadow-sm rounded">
								<thead class="thead-dark border-bottom border-2">
									<tr>
										<th *ngFor="let pair of mappedReviewFieldPairs" class="text-uppercase small fw-bold px-2 py-1">
											{{ pair.mapped }}
											<small class="text-muted" *ngIf="pair.original !== pair.mapped">({{ pair.original }})</small>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let row of matchedOriginalRows">
										<td *ngFor="let pair of mappedReviewFieldPairs" class="px-2 py-1">
											{{ row[pair.original] }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>
				</mat-tab>




			</mat-tab-group>

		</ng-container>
		<ng-container *ngIf="costOverrideHelp">
		  <div class="row cost-override-help">
			<!-- Required Fields -->
			<div class="col-md-6">
			  <h5 class="fw-bold">Required Fields</h5>
			  <p class="small text-muted mb-2">To process cost overrides, the following fields must be mapped:</p>
			  <ul class="list-unstyled small">
				<li><span class="text-primary fw-semibold">✔ stockid</span> <em class="text-muted">(required)</em></li>
				<li><span class="text-primary fw-semibold">✔ cost</span> <em class="text-muted">(required)</em></li>
			  </ul>

			  <h5 class="fw-bold mt-4">Optional Matching Fields</h5>
			  <p class="small text-muted mb-1">If stockid is not provided, use these fields to search for it:</p>
			  <ul class="list-unstyled small">
				<li><span class="text-primary fw-semibold">✔ brand</span></li>
				<li><span class="text-primary fw-semibold">✔ partno</span></li>
			  </ul>
			  <p class="small text-muted">Both must be mapped to enable the "Search Missing SKUs" function.</p>

			  <h5 class="fw-bold mt-4">Notes</h5>
			  <ul class="small text-muted ps-3">
				<li>Setting cost to blank or 0 will remove the override.</li>
				<li>Only one file can be uploaded at a time.</li>
				<li>Columns must be mapped before processing.</li>
				<li>You can remove the uploaded file by clicking the <mat-icon inline>cancel</mat-icon> icon.</li>
			  </ul>
			</div>

			<!-- How To Use -->
			<div class="col-md-6">
			  <h5 class="fw-bold">How To Use</h5>
			  <ol class="small">
				<li>Upload your spreadsheet</li>
				<li>Map each column using the dropdowns</li>
				<li>If needed, search for missing SKUs using brand + partno</li>
				<li>Review matched rows</li>
				<li>Click <strong>Process Matched</strong> to save overrides</li>
			  </ol>

			  <div class="alert alert-info mt-4 small" role="alert">
				<strong>Heads up:</strong> Mapping changes apply instantly — there's no "apply" step.
			  </div>
			</div>
		  </div>
		</ng-container>

	</div>


</ng-template>

<ng-template #costOverrideEdit let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h4 class="modal-title">Forced Cost Override</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body">
		<div class="card">
			<div class="card-header text-center">
				<h5 class="card-title">Edit Cost Override</h5>
			</div>
			<div class="card-body">
				<form [formGroup]="forcedCostOverrideForm" class="container">
					<div class="mb-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Item#</mat-label>
							<input matInput formControlName="stockid" />
						</mat-form-field>
					</div>
					<div class="mb-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Override Cost</mat-label>
							<input type="number" matInput formControlName="override_cost" step="0.01" />
						</mat-form-field>
					</div>
					<div class="text-center">
						<button mat-stroked-button color="primary" (click)="saveForcedCostOverride()">
							<mat-icon>save</mat-icon> Save
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</ng-template>

<div class="container-fluid mt-3">
	<div class="row mb-3">
		<div class="col-12">
			<div class="d-flex flex-wrap justify-content-between align-items-center">
				<div class="d-flex flex-wrap gap-2">
					<button mat-stroked-button color="primary" (click)="uploadForcedCostOverride()" [disabled]="overidesLoading">
						<mat-icon>upload</mat-icon> Upload Override
					</button>
					<button mat-stroked-button color="primary" (click)="addForcedCostOverride()" [disabled]="overidesLoading">
						<mat-icon>add</mat-icon> Add Override
					</button>
				</div>
				<div class="d-flex flex-wrap gap-2">
					<button class="btn btn-danger" (click)="exportForcedCostOverridePDF()" [disabled]="!forcedCostOverrides.length">
						<i class="fa fa-file-pdf-o"></i> Export PDF
					</button>
					<button class="btn btn-success" (click)="exportForcedCostOverrideExcel()" [disabled]="!forcedCostOverrides.length">
						<i class="fa fa-file-excel-o"></i> Export Excel
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<div class="mat-elevation-z2 p-3">
				<div class="d-flex justify-content-between align-items-center mb-3">
					<strong>Results</strong>
					<ng-container *ngIf="overidesLoading">
						<svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</ng-container>
					<ng-container *ngIf="!overidesLoading">({{ forcedCostOverrides.length }})</ng-container>
				</div>
				<mat-form-field appearance="outline" class="w-100 mb-3">
					<mat-label>Filter</mat-label>
					<input matInput (keyup)="applyFilterCostOverride($event)" placeholder="Search items" />
				</mat-form-field>
				<div class="table-responsive">
					<table mat-table [dataSource]="forcedCostOverrideDataSource" matSort #forcedCostOverrideSort="matSort">
						<ng-container matColumnDef="stockid">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Item#</th>
							<td mat-cell *matCellDef="let item">{{ item.stockid }}</td>
						</ng-container>
						<ng-container matColumnDef="description">
							<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
							<td mat-cell *matCellDef="let item">{{ item.description }}</td>
						</ng-container>
						<ng-container matColumnDef="override_cost">
							<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Override Cost</th>
							<td mat-cell *matCellDef="let item" class="text-center">{{ item.override_cost || '0.00' }}</td>
						</ng-container>
						<ng-container matColumnDef="actions">
							<th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
							<td mat-cell *matCellDef="let item" class="text-center">
								<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More actions">
									<mat-icon>more_vert</mat-icon>
								</button>
								<mat-menu #menu="matMenu">
									<button mat-menu-item (click)="editForcedCostOverride(item)">
										<mat-icon>edit</mat-icon> Edit
									</button>
									<button mat-menu-item (click)="removeForcedCostOverride(item)">
										<mat-icon>delete</mat-icon> Remove
									</button>
								</mat-menu>
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="forcedCostOverrideDisplayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: forcedCostOverrideDisplayedColumns;"></tr>
						<tr class="mat-row" *matNoDataRow>
							<td class="mat-cell text-center" colspan="4">No data matching the filter</td>
						</tr>
					</table>
					<mat-paginator #forcedCostOverridePaginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault" aria-label="Select page of forced cost overrides"></mat-paginator>
				</div>
			</div>
		</div>
	</div>
</div>